<template>
    <SidebarSection class="filters">
        <div class="filters__title-block">
            <h2 class="filters__title">{{ $t('search.filters.main.title') }}</h2>
            <LinkButton icon="refresh" data-testid="reset-filters-button" no-text-decoration @click="filtersStore.resetFilters">
                {{ $t('search.filters.reset') }}
            </LinkButton>
        </div>
        <FiltersSummary class="filters__row" />
        <PriceHistogramFilter
            v-if="availableSearchFilters?.priceHistogram.data.length"
            :price-histogram="availableSearchFilters?.priceHistogram"
            class="filters__row"
        />
        <BadgesFilter v-if="availableSearchFilters?.badges.length" class="filters__row" />
        <MicroConsultingEntryPoint class="filters__row" />
        <ExperienceLevelsFilter v-if="availableSearchFilters?.experienceLevels.length" class="filters__row" />
        <SpecialitiesFilter v-if="availableSearchFilters?.specialities.length" class="filters__row" />
        <CategoriesFilter v-if="availableSearchFilters?.categories.length" class="filters__row" />
        <LanguagesFilter v-if="availableSearchFilters?.languages.length" class="filters__row" />
        <BusinessSectorsFilter v-if="availableSearchFilters?.businessSectors.length" class="filters__row" />
        <AdminFilters v-if="availableSearchFilters?.adminFilters?.filters.length" class="filters__row" />
    </SidebarSection>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import LinkButton from '~/components/common/LinkButton.vue';
    import SidebarSection from '~/components/common/SidebarSection.vue';
    import AdminFilters from './filters/AdminFilters.vue';
    import BadgesFilter from './filters/BadgesFilter.vue';
    import BusinessSectorsFilter from './filters/BusinessSectorsFilter.vue';
    import CategoriesFilter from './filters/CategoriesFilter.vue';
    import ExperienceLevelsFilter from './filters/ExperienceLevelsFilter.vue';
    import FiltersSummary from './filters/FiltersSummary.vue';
    import LanguagesFilter from './filters/LanguagesFilter.vue';
    import MicroConsultingEntryPoint from './filters/MicroConsultingEntryPoint.vue';
    import PriceHistogramFilter from './filters/PriceHistogramFilter.vue';
    import SpecialitiesFilter from './filters/SpecialitiesFilter.vue';
    import {useFiltersStore} from './stores/filters.store';

    const filtersStore = useFiltersStore();
    const {availableSearchFilters} = storeToRefs(filtersStore);
</script>

<style lang="scss" scoped>
    .filters {
        &__title-block {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
            flex-wrap: wrap;
        }

        &__title {
            margin-bottom: 0;
            font-family: var(--joy-font-family-title);
            font-weight: var(--joy-font-weight-normal);
            font-size: var(--joy-font-size-secondary-200);
            line-height: var(--joy-line-height-small);
        }

        &__row {
            padding: var(--joy-core-spacing-5) 0;

            &:not(:last-child) {
                border-bottom: 1px solid var(--joy-color-neutral-30);
            }
        }
    }
</style>
